export default __webpack_public_path__ + "static/media/meghan.0a77c91d.jpg";